import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '../shared/shared.module';
import { TenantEffects } from './tenants.effects';
import { tenantFeatureKey } from './tenants.models';
import { tenants } from './tenants.reducer';

@NgModule({
    imports: [SharedModule, StoreModule.forFeature(tenantFeatureKey, tenants), EffectsModule.forFeature([TenantEffects])],
    exports: [],
    declarations: [],
    providers: [],
})
export class TenantsModule {}
